import { render, staticRenderFns } from "./YKSummary.vue?vue&type=template&id=13a6ee06&"
import script from "./YKSummary.vue?vue&type=script&lang=js&"
export * from "./YKSummary.vue?vue&type=script&lang=js&"
import style0 from "./YKSummary.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports